import styles from 'pages/Provider/OrderTest/components/OrderTestItem/OrderTestItem.module.scss';
import { getIconByType, renderIcon } from 'app/helpers/icons';
import { Icon } from 'app/types/Icons';
import { Heading } from 'components/Typography';

import React from 'react';

interface Props {
  title: string;
  icon: Icon;
}

const OrderTestItem: React.FC<Props> = ({ title, icon }) => {
  return (
    <div className={styles.orderTestItem}>

      {getIconByType(icon)}

      <Heading variant="H5">{title}</Heading>

      {renderIcon('arrow', styles.orderTestItem__arrow)}

    </div>
  );
};

export default OrderTestItem;
